import {
  ON_UPDATE_CURRENTUSER_FAVTALPAGEROW,ON_UPDATE_CURRENTUSER_AVTALPAGEROW,
  ON_START_CHANGE_PROSPEKT_KUND,ON_CHANGE_PROSPEKT_KUND,ON_ERROR_CHANGE_PROSPEKT_KUND,
  ON_START_GET_AVTAL_SHARED_KUNDER, ON_GET_AVTAL_SHARED_KUNDER, ON_ERROR_GET_AVTAL_SHARED_KUNDER,
  ON_START_ADD_AVTAL_SHARED_KUNDER, ON_ADD_AVTAL_SHARED_KUNDER, ON_ERROR_ADD_AVTAL_SHARED_KUNDER,
  ON_START_DELETE_AVTAL_SHARED_KUNDER,ON_DELETE_AVTAL_SHARED_KUNDER,ON_ERROR_DELETE_AVTAL_SHARED_KUNDER,
  ON_START_GET_AVTAL_OTASKS, ON_GET_AVTAL_OTASKS, ON_ERROR_GET_AVTAL_OTASKS,
  ON_START_GET_AVTAL_FREEINPUTS,ON_GET_AVTAL_FREEINPUTS,ON_ERROR_GET_AVTAL_FREEINPUTS,
  ON_START_GET_AVTAL_OFFERTL_ID,ON_GET_AVTAL_OFFERTL_ID,ON_ERROR_GET_AVTAL_OFFERTL_ID,
  ON_START_GET_AVTAL_FAKTUROR,ON_GET_AVTAL_FAKTUROR,ON_ERROR_GET_AVTAL_FAKTUROR,
  ON_START_LOADING,ON_END_LOADING,SET_AVTALVY_TYPE,
    ON_SAVE_AVTAL_CALC_ITEMS,
    ON_START_SAVE_AVTAL_CALC_ITEMS,
    ON_ERROR_SAVE_AVTAL_CALC_ITEMS,
    ON_START_GET_AVTAL_ORGNR,ON_CLOSE_AVTAL_TOASTR,KALKYL_ALLREADY_SAVED,
    ON_GET_AVTAL_ORGNR,
    ON_ERROR_GET_AVTAL_ORGNR,
    ON_START_NEW_AVTAL,
    ON_NEW_AVTAL,
    ON_ERROR_NEW_AVTAL,
    ON_START_GET_AVTAL_ID,ON_GET_AVTAL_ID,ON_ERROR_GET_AVTAL_ID,
    ON_START_GET_AVTAL_REST_ID,ON_GET_AVTAL_REST_ID,ON_ERROR_GET_AVTAL_REST_ID,
    ON_START_EDIT_AVTAL,
    ON_EDIT_AVTAL,
    ON_ERROR_EDIT_AVTAL,
    ON_START_NEW_AVTAL_HANDELSE,
    ON_NEW_AVTAL_HANDELSE,
    ON_ERROR_NEW_AVTAL_HANDELSE,
    ON_START_GET_AVTAL_HISTORY_ID,
    ON_GET_AVTAL_HISTORY_ID,
    ON_ERROR_GET_AVTAL_HISTORY_ID,
    ON_START_NEW_AVTAL_KALKYL_ID,
    ON_NEW_AVTAL_KALKYL_ID,
    ON_ERROR_NEW_AVTAL_KALKYL_ID,    
    ON_START_NEW_AVTAL_ABOKALKYL_ID,
    ON_NEW_AVTAL_ABOKALKYL_ID,
    ON_ERROR_NEW_AVTAL_ABOKALKYL_ID,    
    ON_START_GET_AVTAL_KALKYL_ID,
    ON_GET_AVTAL_KALKYL_ID,
    ON_ERROR_GET_AVTAL_KALKYL_ID,
    ON_START_UPDATE_AVTAL_KALKYL_RAD,
    ON_UPDATE_AVTAL_KALKYL_RAD,
    ON_ERROR_UPDATE_AVTAL_KALKYL_RAD,
    ON_START_DELETE_AVTAL_KALKYL_RAD,
    ON_DELETE_AVTAL_KALKYL_RAD,
    ON_ERROR_DELETE_AVTAL_KALKYL_RAD,
    ON_GET_AVTAL_USER,ON_GET_AVTALF_USER,
    ON_START_GET_AVTAL_USER,
    ON_ERROR_GET_AVTAL_USER,
    ON_ERROR_NEW_PROSPEKT,
    ON_NEW_PROSPEKT,
    ON_START_NEW_PROSPEKT,
    ON_START_DELETE_PROSPEKT,
    ON_DELETE_PROSPEKT,ON_UPDATE_PROSPEKT_KUND_PARAMETERS,
    ON_ERROR_DELETE_PROSPEKT,
    ON_START_DELETE_AVTAL,
    ON_DELETE_AVTAL,
    ON_ERROR_DELETE_AVTAL,
    ON_GET_AVTAL_USER_HEADER,    ON_START_GET_AVTAL_USER_HEADER,    ON_ERROR_GET_AVTAL_USER_HEADER,
    ON_START_GET_BILLING_AVTAL_USER_HEADER,ON_GET_BILLING_AVTAL_USER_HEADER,ON_ERROR_GET_BILLING_AVTAL_USER_HEADER,
    ON_AVTAL_NEW_DOC,
    ON_START_AVTAL_NEW_DOC,
    ON_ERROR_AVTAL_NEW_DOC,
    ON_START_GET_AVTAL_DOC_ID,
    ON_GET_AVTAL_DOC_ID,
    ON_ERROR_GET_AVTAL_DOC_ID,
    ON_DELETE_AVTAL_DOC_RAD,
    ON_ERROR_DELETE_AVTAL_DOC_RAD,
    ON_START_DELETE_AVTAL_DOC_RAD,
    ON_GET_AVTAL_ORDER_ID,
    ON_ERROR_GET_AVTAL_ORDER_ID,
    ON_START_GET_AVTAL_ORDER_ID,
    ON_START_DELETE_AVTAL_ORDER_RAD,
    ON_DELETE_AVTAL_ORDER_RAD,
    ON_ERROR_DELETE_AVTAL_ORDER_RAD,
    ON_START_GET_AVTAL_KUNDDATA_ID,
    ON_GET_AVTAL_KUNDDATA_ID,
    ON_ERROR_GET_AVTAL_KUNDDATA_ID,
    ON_START_AVTAL_ANTAL_UPDATE,
    ON_NEW_AVTAL_ANTAL_UPDATE,
    ON_ERROR_AVTAL_ANTAL_UPDATE,
    ON_START_AVTAL_KUNDDATA_INSERT,
    ON_NEW_AVTAL_KUNDDATA_INSERT,
    ON_ERROR_AVTAL_KUNDDATA_INSERT,
    ON_START_AVTAL_KUNDDATA_COPYTA,
    ON_AVTAL_KUNDDATA_COPYTA,
    ON_ERROR_AVTAL_KUNDDATA_COPYTA,
    ON_START_DELETE_AVTAL_KUNDDATA_RAD,
    ON_DELETE_AVTAL_KUNDDATA_RAD,
    ON_ERROR_DELETE_AVTAL_KUNDDATA_RAD,
    ON_START_GET_AVTAL_Event_ID,
    ON_GET_AVTAL_Event_ID,
    ON_ERROR_GET_AVTAL_Event_ID,
    ON_START_AVTAL_KUNDDATA_TEMPORARY, ON_AVTAL_KUNDDATA_TEMPORARY, ON_ERROR_AVTAL_KUNDDATA_TEMPORARY,
    ON_START_AVTAL_IMPORT_KD_EXCEL, ON_AVTAL_IMPORT_KD_EXCEL, ON_ERROR_AVTAL_IMPORT_KD_EXCEL,
    ON_START_FORTNOX_NEWKUND_AVTAL, ON_FORTNOX_NEWKUND_AVTAL, ON_ERROR_FORTNOX_NEWKUND_AVTAL,
    ON_START_CHANGE_ANSVARIG_AVTALLIST,ON_CHANGE_ANSVARIG_AVTALLIST,ON_ERROR_CHANGE_ANSVARIG_AVTALLIST,
    ON_START_DELETE_AVTALLIST,ON_DELETE_AVTALLIST,ON_ERROR_DELETE_AVTALLIST,
    ON_START_CHANGE_DATE_AVTALLIST,ON_CHANGE_DATE_AVTALLIST,ON_ERROR_CHANGE_DATE_AVTALLIST,
    ON_START_AVTAL_TILLBAKA, ON_AVTAL_TILLBAKA, ON_ERROR_AVTAL_TILLBAKA,
    ON_START_DELETE_AVTAL_HANDELSE,ON_DELETE_AVTAL_HANDELSE,ON_ERROR_DELETE_AVTAL_HANDELSE,
    ON_START_UPDATER_AVTAL_HANDELSE,ON_UPDATER_AVTAL_HANDELSE,ON_ERROR_UPDATER_AVTAL_HANDELSE,
    ON_START_PROSPEKT_FORLORAD, ON_PROSPEKT_FORLORAD, ON_ERROR_PROSPEKT_FORLORAD,
    ON_START_PROSPEKT_TILLBAKA, ON_PROSPEKT_TILLBAKA, ON_ERROR_PROSPEKT_TILLBAKA,
    ON_START_OMFORHANDLA_AVTAL,ON_OMFORHANDLA_AVTAL,ON_ERROR_OMFORHANDLA_AVTAL,
    ON_START_CHANGE_START_BILLING_AVTALLIST,ON_CHANGE_START_BILLING_AVTALLIST,ON_ERROR_CHANGE_START_BILLING_AVTALLIST,
    ON_START_AVTAL_BILLING_START, ON_AVTAL_BILLING_START, ON_ERROR_AVTAL_BILLING_START,
    ON_START_AVTAL_BILLING_CLOSE, ON_AVTAL_BILLING_CLOSE, ON_ERROR_AVTAL_BILLING_CLOSE,
    ON_START_AVTAL_BILLING_UPDATE, ON_AVTAL_BILLING_UPDATE, ON_ERROR_AVTAL_BILLING_UPDATE,
    ON_START_CHANGE_CLOSE_BILLING_AVTALLIST,ON_CHANGE_CLOSE_BILLING_AVTALLIST,ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST,
    ON_START_CHANGE_SKAPA_BILLING_AVTALLIST,ON_CHANGE_SKAPA_BILLING_AVTALLIST,ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST,
    ON_START_UPDATE_AVTAL_DOC_RAD,ON_UPDATE_AVTAL_DOC_RAD,ON_ERROR_UPDATE_AVTAL_DOC_RAD, ON_GET_AVTAL_PAGE_BASIC,
    ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,
    ON_GET_ALL_HANDELSE_AVTAL,
    ON_START_GET_ALL_HANDELSE_AVTAL,
    ON_ERROR_GET_ALL_HANDELSE_AVTAL,
    FETCH_START_SET_UNAUTHE
} from "../constants/ActionTypes";
import { history } from "store";
import axios from 'util/Api' 
import { isEmpty,isUndefined } from "lodash";
import {RefreshUserInterface,getProspektByUserid1} from 'actions'
import { translate } from "../util/intlHelper";

const getClientIp = async () => {
  let Ipadress='0.0.0.0'
      await fetch('http://ip-api.com/json')
      .then(response => response.json())
      .then(data => {console.log(data)
      Ipadress= data.query || "0.0.0.0"});
      return Ipadress
}
 //getAvtalByOrgnr
 export const getAvtalByOrgnr = (userid,Afid,Orgnr,type,page,seachWord) =>{
   let Page = isUndefined(page)?0:page
   let SeachWord = isUndefined(seachWord)?'':seachWord
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_ORGNR});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Contracts")});
    axios.get('kontos/Avtal/getByOrgnr',
    { params:{Orgnr:Orgnr,Afid:Afid,userid:userid,page:Page,type:type,SeachWord:SeachWord,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AVTAL_ORGNR, payload: data.results});
         dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Contracts")});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_ORGNR, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload:translate("Error.fetch.Contracts") });
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_ORGNR, payload: errorMessage});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
     });
  }
}
//getAvtalByID
export const getAvtalByRestID = (Orgrn,Afid,userid,Avtal,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_REST_ID});
    axios.get('kontos/Avtal/getRestById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Avtal:Avtal}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByID: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_REST_ID, payload: data.results});        
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_REST_ID, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_REST_ID, payload: errorMessage});
     }); /**/
  }
}
export const getAvtalByID = (Orgrn,Afid,userid,Avtal,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_ID});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Contract")});
    axios.get('kontos/Avtal/getById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Avtal:Avtal,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByID: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_ID, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Contract",`#19${data.results.Avtal.Avtal[0].id} har hämtat`,{AvtalId:data.results.Avtal.Avtal[0].id})});
        if(data.results.Avtal.Avtal[0].typeFlag ===2 || data.results.Avtal.Avtal[0].typeFlag ===3){
          history.push({
            pathname: '/app/ProspektKort',
            state: { AvtalId: data.results.Avtal.Avtal[0] }
          });
        }
        else{
        history.push({
          pathname: '/app/AvtalsKort',
          state: { AvtalId: data.results.Avtal.Avtal[0] }
        })
        }
        localStorage.setItem("Avtal",`${data.results.Avtal.Avtal[0].id}_${data.results.Avtal.Avtal[0].Orgnr}`);
        dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_ID, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.Contract")});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_ID, payload: errorMessage});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
     }); /**/
  }
}
//getAvtalAllHandlese
    // ON_GET_ALL_HANDELSE_AVTAL,
    // ON_START_GET_ALL_HANDELSE_AVTAL,
    // ON_ERROR_GET_ALL_HANDELSE_AVTAL,
export const getAvtalAllHandlese = (Orgnr,Afid,userid,Avtalid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ALL_HANDELSE_AVTAL});
    axios.get('kontos/Avtal/allHandelse',
    { params:{Orgnr:Orgnr,Afid:Afid,userid:userid,Avtalid:Avtalid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalAllHandlese: ", data);
       if (data.results) {
        dispatch({type: ON_GET_ALL_HANDELSE_AVTAL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_ALL_HANDELSE_AVTAL, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_ALL_HANDELSE_AVTAL, payload: errorMessage});
     }); /**/
  }
}
//getAvtalHistorikById
export const getAvtalHistorikById = (Orgrn,Afid,userid,Avtal,SHDialer,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_HISTORY_ID});
    axios.get('kontos/Avtal/gethistoryById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Avtal:Avtal,ipAdress,SHDialer}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByID: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_HISTORY_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_HISTORY_ID, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_HISTORY_ID, payload: errorMessage});
     }); /**/
  }
}
//getAvtalKalkylById
export const getAvtalKalkylById = (Orgrn,Afid,userid,Avtal,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_KALKYL_ID});
    axios.get('kontos/Avtal/getKalkylById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Avtal:Avtal,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByID: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_KALKYL_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_KALKYL_ID, payload: data.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_KALKYL_ID, payload: errorMessage});
     }); /**/
  }
}

//createNewAvtal
export const createNewAvtal = (userid,Afid,Navtal) =>{
    const jwt =  JSON.parse(localStorage.token);
     return async (dispatch) => {
      const ipAdress='0.0.0.0'
      localStorage.removeItem("Avtal");
       dispatch({type: ON_START_NEW_AVTAL});
       dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Creating.Cointract")});
       axios.put('kontos/Avtal/new', {
        body: {
          Avtal:Navtal,
          Afid:Afid,
          userid:userid,ipAdress
        }},{
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
        console.log("createNewAvtal: ", data);
         if (data.results) {
          // dispatch({type: FETCH_ALL_CONTACT});
           dispatch({type: ON_NEW_AVTAL, payload: data.results});
           dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Create.Cointract",`Avtal #19${data.results.Avtal.Avtal[0].id} har skapats`,{AvtalId:data.results.Avtal.Avtal[0].id})});
           localStorage.setItem("Avtal",`${data.results.Avtal.Avtal[0].id}_${data.results.Avtal.Avtal[0].Orgnr}`);
           history.push({
            pathname: '/app/AvtalsKort',
            state: { AvtalId: data.results.Avtal.Avtal[0] }
          });
         } else {
           dispatch({type: ON_ERROR_NEW_AVTAL, payload: data.error});
           dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Create.Cointract")});
         }
         //dispatch(RefreshUserInterface(userid))
       }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
         dispatch({type: ON_ERROR_NEW_AVTAL, payload: errorMessage});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
       });
     }
   } 
   //saveAvtalByIDdel1
 export const saveAvtalByID = (Afid,userid,edavtal,Box) =>{
 const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_EDIT_AVTAL});
     dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Saving.Cointract")});
     axios.put('kontos/Avtal/Edit', {
      body: {
        Afid:Afid,
        userid:userid,
        Box:Box,
        edavtal:edavtal,ipAdress
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("saveAvtalByID: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_EDIT_AVTAL, payload: data.results});
         dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Save.Cointract",`Avtal #19${data.results.Avtal.Avtal[0].id} har sparats`,{AvtalId:data.results.Avtal.Avtal[0].id})});
         dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
       } else {
         dispatch({type: ON_ERROR_EDIT_AVTAL, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Save.Cointract")});
       }
       //dispatch(RefreshUserInterface(userid))
       let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
     //  dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_EDIT_AVTAL, payload: errorMessage});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
     });
   }
}
//SaveAvtalNewHandelse
export const SaveAvtalNewHandelse = (Afid,userid,Orgnr,Aid,handelse) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    console.log(handelse,"KACJ")
  let files = handelse.file;
  const ipAdress='0.0.0.0'
  console.log(files)
  var fromdata = new FormData();
  fromdata.append("Avtal",Aid)
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("ipAdress",ipAdress)
  fromdata.append("handelse",handelse.text)
  fromdata.append("Type","Avtal Anteckning")
  if(files !==""){
     files.forEach(file => fromdata.append('files[]', file));
  }
  console.log(!isEmpty(files))
  
    
    dispatch({type: ON_START_NEW_AVTAL_HANDELSE});
    axios.post('kontos/Avtal/handelse/new',
    fromdata,
     {
       body:{
        Orgnr:Orgnr,
        Avtal:Aid,
        Afid:Afid,
        userid:userid,
        text:handelse.text,
        Type:"Avtal Anteckning",ipAdress
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
    console.log("NEwhandelse: ", data);
     if (data.results) {
       dispatch({type: ON_NEW_AVTAL_HANDELSE, payload: data.results});
       dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
     } else {
       dispatch({type: ON_ERROR_NEW_AVTAL_HANDELSE, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   }).catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_NEW_AVTAL_HANDELSE, payload: errorMessage});
   });
  } 
}
//saveNewNormalKalkyl
export const saveNewNormalKalkyl = (Afid,userid,Aid,Orgnr,nKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_NEW_AVTAL_KALKYL_ID});
      axios.put('kontos/Avtal/KalkylNormal/new', {
       body: {
         Afid:Afid,
         userid:userid,
         Aid:Aid,
         Orgnr:Orgnr,
         Kalkyl:nKalkyl,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveNewNormalKalkyl: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_AVTAL_KALKYL_ID, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
        } else {
          dispatch({type: ON_ERROR_NEW_AVTAL_KALKYL_ID, payload: data.error});
        }
        let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
      // dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_NEW_AVTAL_KALKYL_ID, payload:errorMessage});
      });
    }
 }

export const onSaveAvtalCalcItems = (AvtalId, Orgnr, CalcItems, CalcItemsUpdatesArr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_SAVE_AVTAL_CALC_ITEMS});
      axios.post('kontos/Avtal/onSaveAvtalCalcItems', {
        AvtalId, Orgnr, CalcItems, CalcItemsUpdatesArr
      }, 
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      }).then(({data}) => {
       console.log("onSaveOrderCalcItems: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_SAVE_AVTAL_CALC_ITEMS, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_SAVE_AVTAL_CALC_ITEMS, payload: data.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_SAVE_AVTAL_CALC_ITEMS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //saveNewAbonnemangKalkyl
 export const saveNewAbonnemangKalkyl = (Afid,userid,Aid,Orgnr,nKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_NEW_AVTAL_ABOKALKYL_ID});
      axios.put('kontos/Avtal/KalkylAbonnemange/new', {
       body: {
         Afid:Afid,
         userid:userid,
         Aid:Aid,
         Orgnr:Orgnr,
         Kalkyl:nKalkyl,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveNewAbonnemangKalkyl: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_AVTAL_ABOKALKYL_ID, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
        } else {
          dispatch({type: ON_ERROR_NEW_AVTAL_ABOKALKYL_ID, payload: data.error});
        }
        let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
     //  dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_NEW_AVTAL_ABOKALKYL_ID, payload: errorMessage});
      });
    }
 }
export const UpdateNormalKalkyl=(Afid,userid,Aid,Orgnr,Kalkyl,newKalkyl)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_UPDATE_AVTAL_KALKYL_RAD});
    axios.put('kontos/Avtal/Kalkyl/All/update', {
     body: {
       Afid:Afid,
       userid:userid,
       Kalkyl:Kalkyl,
       Orgnr:Orgnr,
       Aid:Aid,
       newKalkyl:newKalkyl,
       ipAdress
     }},{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("updateThisRowKalkyl: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_UPDATE_AVTAL_KALKYL_RAD, payload: data.results});
        dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
      } else {
        dispatch({type: ON_ERROR_UPDATE_AVTAL_KALKYL_RAD, payload: data.error});
      }
      let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
      dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
      dispatch({type: ON_ERROR_UPDATE_AVTAL_KALKYL_RAD, payload:errorMessage});
    });
  }
}
//updateThisRowKalkyl
export const updateThisRowKalkyl = (Afid,userid,nrad) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_UPDATE_AVTAL_KALKYL_RAD});
      axios.put('kontos/Avtal/Kalkyl/update', {
       body: {
         Afid:Afid,
         userid:userid,
         nrad:nrad,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("updateThisRowKalkyl: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_AVTAL_KALKYL_RAD, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
        } else {
          dispatch({type: ON_ERROR_UPDATE_AVTAL_KALKYL_RAD, payload: data.error});
        }
        let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
        dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_UPDATE_AVTAL_KALKYL_RAD, payload:errorMessage});
      });
    }
 }
//deleteThisRowKalkyl
export const deleteThisRowKalkyl = (Afid,userid,nrad) =>{
   const jwt = JSON.parse(localStorage.token);;
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_DELETE_AVTAL_KALKYL_RAD});
      axios.delete('kontos/Avtal/Kalkyl/delete', {
        method: 'DELETE',
        data: {
          rad:nrad,
          Afid:Afid,
          userid:userid,ipAdress
        },
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
      console.log("deleteThisRowKalkyl: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: ON_DELETE_AVTAL_KALKYL_RAD, payload: data});
        dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
      } else {
        dispatch({type: ON_ERROR_DELETE_AVTAL_KALKYL_RAD, payload: data.error});
      }
      let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
       dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
    })
    .catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
      dispatch({type: ON_ERROR_DELETE_AVTAL_KALKYL_RAD, payload: errorMessage});
    });
    }
 }
//deleteAvtalOrderByID
export const deleteAvtalOrderByID = (Afid,userid,Order) =>{
   const jwt = JSON.parse(localStorage.token);;
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_DELETE_AVTAL_ORDER_RAD});
      axios.delete('kontos/Avtal/Order/delete', {
        method: 'DELETE',
        data: {
          Order:Order,
          Afid:Afid,
          userid:userid,ipAdress
        },
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then(({data}) => {
      console.log("deleteAvtalOrderByID: ", data.message);
      if (data.success) {
        console.log(data);
        dispatch({type: ON_DELETE_AVTAL_ORDER_RAD, payload: data.results});
        dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
      } else {
        dispatch({type: ON_ERROR_DELETE_AVTAL_ORDER_RAD, payload: data.error});
      }
      //dispatch(RefreshUserInterface(userid))
    })
    .catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
      dispatch({type: ON_ERROR_DELETE_AVTAL_ORDER_RAD, payload: errorMessage});
    });
    }
 }
 //getAvtalByUserid
export const getAvtalByUserid = (Afid,Filterstate,userid,type,page,searchWord,Pagerows,sortObj) =>{
  console.log('TYPE ::: 2',  type)
  const jwt =  JSON.parse(localStorage.token);
  page = isUndefined(page)?0:page
  Pagerows = isUndefined(Pagerows)?25:Pagerows
  searchWord = isUndefined(searchWord)?"":searchWord
  sortObj = isUndefined(sortObj)?null:sortObj
  return async (dispatch) => {
    localStorage.removeItem("Avtal")
    //dispatch(RefreshUserInterface(userid))
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_USER});
    axios.get('kontos/Avtal/getByUser',
    { params:{Afid:Afid,userid:userid,page:page,searchWord:searchWord,Filterstate:Filterstate,type:type,ipAdress,Pagerows, sortObj}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByUserid: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
        if(parseInt(type) === 3){
          dispatch({type: ON_GET_AVTALF_USER, payload: data.results});
        //  dispatch({type: ON_UPDATE_CURRENTUSER_FAVTALPAGEROW,payload: data.results.Pagerows})
        }else{
          dispatch({type: ON_GET_AVTAL_USER, payload: data.results});
          //dispatch({type: ON_UPDATE_CURRENTUSER_AVTALPAGEROW,payload: data.results.Pagerows})
        }
        
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_USER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      console.log("Error in getAvtalByUserid: ", error);
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       console.log("Error in getAvtalByUserid: ", errorMessage)
       dispatch({type: ON_ERROR_GET_AVTAL_USER, payload: errorMessage});
     }); 
  }
}
 //getAvtalByUserIdHeader
export const getAvtalByUserIdHeader = (Afid,Filterstate,userid,searchWord,type) =>{
  console.log('TYPE ::: 1',  type)
  const jwt =  JSON.parse(localStorage.token);
  searchWord = isUndefined(searchWord)?"":searchWord
  type = isUndefined(type)?0:type
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_USER_HEADER});
    axios.get('kontos/Avtal/getByUserHeadar',
    { params:{Afid:Afid,userid:userid,searchWord:searchWord,Filterstate:Filterstate,type,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByUserIdHeader: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AVTAL_USER_HEADER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_USER_HEADER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_USER_HEADER, payload: errorMessage});
     });
  }
}
//getBillingAvtalByUserIdHeader
export const getBillingAvtalByUserIdHeader = (Afid,Filterstate,userid,searchWord, type) =>{
  const jwt =  JSON.parse(localStorage.token);
  searchWord = isUndefined(searchWord)?"":searchWord
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_BILLING_AVTAL_USER_HEADER});
    axios.get('kontos/Avtal/getByBillingUserHeadar',
    { params:{Afid:Afid,userid:userid,searchWord:searchWord,Filterstate:Filterstate,ipAdress,type}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getBillingAvtalByUserIdHeader: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_BILLING_AVTAL_USER_HEADER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_BILLING_AVTAL_USER_HEADER, payload: data.error});
       }
       dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_BILLING_AVTAL_USER_HEADER, payload: errorMessage});
     });
  }
}

//createNewProspekt
export const createNewProspekt = (userid,Afid,Navtal,Source,FSource) =>{
  let SourceId = isUndefined(Source)?0:Source
  let FromSource = isUndefined(FSource)?0:FSource
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_NEW_PROSPEKT});
     dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Createing.Prospect")});
     dispatch({type: ON_START_LOADING});
     axios.put('kontos/Prospekt/new', {
      body: {
        Avtal:Navtal,
        Afid:Afid,
        userid:userid,
        SourceId:SourceId,
        FromSource:FromSource,ipAdress
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createNewProspekt: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_NEW_PROSPEKT, payload: data.results});
         dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Create.Prospect",`Prospekt #19${data.results.Avtal.Avtal[0].id} har skapats`,{AvtalId:data.results.Avtal.Avtal[0].id})});
         history.push({
          pathname: '/app/ProspektKort',
          state: { AvtalId: data.results.Avtal.Avtal[0] }
        });
        localStorage.setItem("Avtal",`${data.results.Avtal.Avtal[0].id}_${data.results.Avtal.Avtal[0].Orgnr}`);
        dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
        dispatch({type: ON_END_LOADING});
       } else {
         dispatch({type: ON_ERROR_NEW_PROSPEKT, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Create.Prospect")});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_NEW_PROSPEKT, payload: errorMessage});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
       dispatch({type: ON_END_LOADING});
     });
   }
 } 
//deleteProspektByID 
export const deleteProspektByID = ( Afid, userid, Avtal,page,type,KundPage,seachWord) =>{
  let KundType = isUndefined(type)?"":type
  let kundPage = isUndefined(KundPage)?"0":KundPage
  let SeachWord = isUndefined(seachWord)?"":seachWord
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    if(parseInt(page) !== 1){
      history.push({
        pathname: '/app/Prospekt'
      });
     }
     dispatch({type: ON_START_DELETE_PROSPEKT});
     dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Deleting.Prospect")});
     axios.delete('kontos/Prospekt/delete', {
       method: 'DELETE',
       data: {
         Afid:Afid,
         userid:userid,
         Avtal:Avtal,
         KundType:KundType,
         kundPage:kundPage,
         SeachWord:SeachWord,
         type:type,
         ipAdress
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteAvtalByID: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_PROSPEKT, payload: data.results});
       dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Delete.Prospect",`Prospekt #19${Avtal.id} har raderats`,{AvtalId:Avtal.id})});
       dispatch({type: ON_UPDATE_PROSPEKT_KUND_PARAMETERS, payload: data.results});
       let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
       dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
     } else {
       dispatch({type: ON_ERROR_DELETE_PROSPEKT, payload: data.error});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Delete.Prospect")});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_PROSPEKT, payload: errorMessage});
     dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
   });
   }
}
//deleteAvtalByID 
export const deleteAvtalByID = ( Afid, userid, Avtal,page,Forlorad) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    
    
     dispatch({type: ON_START_DELETE_AVTAL});
     dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Deleting.Contract")});
     axios.delete('kontos/Avtal/delete', {
       method: 'DELETE',
       data: {
         Afid:Afid,
         userid:userid,
         Forlorad:Forlorad,
         Avtal:Avtal,ipAdress
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteAvtalByID: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_AVTAL, payload: data.results});
       dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Delete.Contract",`Avtal #19${Avtal.id} har raderats`,{AvtalId:Avtal.id})});
       if(isEmpty(Avtal.Orgnr)){
        if(parseInt(page) !== 1){
          history.push({
            pathname: '/app/Avtal'
          });
         }
      }
      else{
        history.push({
          pathname: '/app/Kund',
          state: { Orgnr: Avtal.Orgnr }
        });
      }
     } else {
       dispatch({type: ON_ERROR_DELETE_AVTAL, payload: data.error});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Delete.Contract")});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_AVTAL, payload: errorMessage});
     dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
   });
   }
}
//omForHandlaAvtalByID 
export const omForHandlaAvtalByID = ( Afid, userid, Avtal) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_OMFORHANDLA_AVTAL});
     axios.put('kontos/Avtal/omForhandla', {
       data: {
         Afid:Afid,
         userid:userid,
         Avtal:Avtal,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteAvtalByID: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_OMFORHANDLA_AVTAL, payload: data.results});
       dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
       let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
       dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
       
     } else {
       dispatch({type: ON_ERROR_OMFORHANDLA_AVTAL, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_OMFORHANDLA_AVTAL, payload: errorMessage});
   });
   }
}
export const omForHandlaAvtalByIDUndo = ( Afid, userid, Avtal) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_OMFORHANDLA_AVTAL});
     axios.put('kontos/Avtal/omForhandlaUndo', {
       data: {
         Afid:Afid,
         userid:userid,
         Avtal:Avtal,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteAvtalByID: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_OMFORHANDLA_AVTAL, payload: data.results});
       let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
       dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
       
     } else {
       dispatch({type: ON_ERROR_OMFORHANDLA_AVTAL, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_OMFORHANDLA_AVTAL, payload: errorMessage});
   });
   }
}

//saveNewDocAvtal
 export const saveNewDocAvtal = (Orgrn, Afid, userid,Avtal,Doc) =>{
  const jwt =  JSON.parse(localStorage.token);
  
  return async (dispatch) => {
    let files = Doc.file; 
    const ipAdress='0.0.0.0'
  var fromdata = new FormData();
  fromdata.append("Orgnr",Orgrn)
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("Avtal",Avtal)
  fromdata.append("ipAdress",ipAdress)
  fromdata.append("DocType",Doc.type)
  fromdata.append("DocName",Doc.Name)
  files.forEach(file => fromdata.append('files[]', file));
    
    dispatch({type: ON_START_AVTAL_NEW_DOC});
    axios.post('kontos/Avtal/Doc/new',
    fromdata,
     {
       body:{
        Orgnr:Orgrn,
        Afid:Afid,
        userid:userid,
        Avtal:Avtal,
        DocType:Doc.type,
        DocName:Doc.Name,ipAdress
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
    console.log("saveNewDocAvtal: ", data);
     if (data.results) {
      // dispatch({type: FETCH_ALL_CONTACT});
       dispatch({type: ON_AVTAL_NEW_DOC, payload: data.results});
       dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
     } else {
       dispatch({type: ON_ERROR_AVTAL_NEW_DOC, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   }).catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_AVTAL_NEW_DOC, payload: errorMessage});
   });
  } 
 }
//getAvtalDocsById
export const getAvtalDocsById = (Orgrn,Afid,userid,Avtal,NoMes) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_DOC_ID});
    if(isUndefined(NoMes)){
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Document")});
    }
    axios.get('kontos/Avtal/getDOCById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Avtal:Avtal,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalDocsById: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_DOC_ID, payload: data.results});
        if(isUndefined(NoMes)){
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Document")});
        }
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_DOC_ID, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.Document")});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_DOC_ID, payload:errorMessage});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
     }); /**/
  }
}
//getAvtalOrderById
export const getAvtalOrderById = (Orgrn,Afid,userid,Avtal,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_ORDER_ID});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Orders")});
    axios.get('kontos/Avtal/getOrderById',
    { params:{Orgnr:Orgrn,Afid:Afid,userid:userid,Avtal:Avtal,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalOrderById: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_ORDER_ID, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Orders")});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_ORDER_ID, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.Orders")});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_ORDER_ID, payload:errorMessage});
     }); /**/
  }
}
//deleteThisDoc
export const deleteThisDoc = (Afid,userid,drad) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_AVTAL_DOC_RAD});
     axios.delete('kontos/Avtal/Doc/delete', {
       method: 'DELETE',
       data: {
         rad:drad,
         Afid:Afid,
         userid:userid,ipAdress
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisDoc: ", data.results);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_AVTAL_DOC_RAD, payload: data.results});
       dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
       dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Delete.document")});
     } else {
       dispatch({type: ON_ERROR_DELETE_AVTAL_DOC_RAD, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_AVTAL_DOC_RAD, payload: errorMessage});
   });
   }
}

//updateThisDoc
export const updateThisDocAvtal = (Afid,userid,Updatedrad) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_UPDATE_AVTAL_DOC_RAD});
    axios.put('kontos/Avtal/Doc/update', {
     body: {
       Afid:Afid,
       userid:userid,
       Updatedrad:Updatedrad,
       ipAdress:ipAdress,
     }},{
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then(({data}) => {
     console.log("updateThisDoc: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_UPDATE_AVTAL_DOC_RAD, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Edit.document")});
      } else {
        dispatch({type: ON_ERROR_UPDATE_AVTAL_DOC_RAD, payload: data.error});
      }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
      dispatch({type: ON_ERROR_UPDATE_AVTAL_DOC_RAD, payload: errorMessage});
    });
  }
}
//getAvtalKundData
export const getAvtalKundData = (Afid,userid,Aid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_KUNDDATA_ID});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.ClientData")});
    axios.get('kontos/Avtal/Kunddata/getByOid',
    { params:{Afid:Afid,userid:userid,Avtal:Aid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalKundData: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_KUNDDATA_ID, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.ClientData")});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_KUNDDATA_ID, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.ClientData")});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_KUNDDATA_ID, payload:errorMessage});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
     }); /**/
  }
}
//getAvtalMote
export const getAvtalMote = (Afid,userid,Aid) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_Event_ID});
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Events")});
    axios.get('kontos/Avtal/Event/getByAid',
    { params:{Afid:Afid,userid:userid,Avtal:Aid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalMote: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_Event_ID, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Events")});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_Event_ID, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.Events")});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_KUNDDATA_ID, payload: errorMessage});
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
     }); /**/
  }
}
//saveAvtalAntal
export const saveAvtalAntal =  (Orgnr,Afid,userid,AvtalId,infostate) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_ANTAL_UPDATE});
      axios.put('kontos/Avtal/antal/update', {
       body: {
         Afid:Afid,
         userid:userid,
         AvtalId:AvtalId,
         Orgnr:Orgnr,
         infostate:infostate,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveOrderAntal: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_AVTAL_ANTAL_UPDATE, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
        } else {
          dispatch({type: ON_ERROR_AVTAL_ANTAL_UPDATE, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_ANTAL_UPDATE, payload: errorMessage});
      });
    }
 }
//saveThoseAvKundDataNew
export const saveAvtalAntalNew =  (Afid, userid, AvtalId, KundData, Orgnr, infoState, type) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_ANTAL_UPDATE});
      axios.put('kontos/Avtal/antalNew/update', {
       body: {
         Afid:Afid,
         userid:userid,
         AvtalId:AvtalId,
         Orgnr:Orgnr,
         Kunddata:JSON.stringify(KundData),
         infoState:infoState,
         ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveThoseAvKundData: ", data);
        if (data.results) {
       /*   type=0 //insert
          type = 1//delete
          */
         console.log(type,"::::::")
         // dispatch({type: FETCH_ALL_CONTACT});
         if(parseInt(type) === 1){
          dispatch({type: ON_DELETE_AVTAL_KUNDDATA_RAD, payload: data.results});
         }
         else{
          dispatch({type: ON_NEW_AVTAL_ANTAL_UPDATE, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
         }
        } else {
          dispatch({type: ON_ERROR_AVTAL_ANTAL_UPDATE, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_ANTAL_UPDATE, payload: errorMessage});
      });
    }
 }
//saveThoseAvKundData
export const saveThoseAvKundData =  (Afid,userid,AvtalId,Kunddata,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_KUNDDATA_INSERT});
      axios.put('kontos/Avtal/Kunddata/insert', {
       body: {
         Afid:Afid,
         userid:userid,
         AvtalId:AvtalId,
         Orgnr:Orgnr,
         Kunddata:Kunddata,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("saveThoseAvKundData: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_NEW_AVTAL_KUNDDATA_INSERT, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
        } else {
          dispatch({type: ON_ERROR_AVTAL_KUNDDATA_INSERT, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_KUNDDATA_INSERT, payload: errorMessage});
      });
    }
 }
//CopytoKDAvRows
export const CopytoKDAvRows =  (Afid,userid,AvtalId,Meta,Value,Kunddata,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_KUNDDATA_COPYTA});
      axios.put('kontos/Avtal/Kunddata/CopyToAll', {
       body: {
         Afid:Afid,
         userid:userid,
         AvtalId:AvtalId,
         Orgnr:Orgnr,
         Meta:Meta,
         Value:Value,
         Kunddata:Kunddata,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("CopytoKDAvRows: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_AVTAL_KUNDDATA_COPYTA, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_AVTAL_KUNDDATA_COPYTA, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_KUNDDATA_COPYTA, payload: errorMessage});
      });
    }
 }
//deleteThisRowKundDataAvtal
export const deleteThisRowKundDataAvtal = (Afid,userid,Aid,nrad,Orgnr) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_AVTAL_KUNDDATA_RAD});
     axios.delete('kontos/Avtal/Kunddata/delete', {
       method: 'DELETE',
       data: {
         rad:nrad,
         AvtalId:Aid,
         Orgnr:Orgnr,
         Afid:Afid,
         userid:userid,ipAdress
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisRowKundDataAvtal: ", data);
     if (data.success) {
       dispatch({type: ON_DELETE_AVTAL_KUNDDATA_RAD, payload: data.results});
       dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
     } else {
       dispatch({type: ON_ERROR_DELETE_AVTAL_KUNDDATA_RAD, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_AVTAL_KUNDDATA_RAD, payload: errorMessage});
   });
   }
}
//deleteThisProspektWithOrder
export const deleteThisProspektWithOrder = (Afid,userid,Avtal) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_PROSPEKT});
     axios.delete('kontos/Prospekt/Order/delete', {
       method: 'DELETE',
       data: {
        Afid:Afid,
        userid:userid,
        Avtal:Avtal,ipAdress
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisProspekt: ", data);
     if (data.success) {
      let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
      dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
      history.push({
        pathname: '/app/Prospekt'
      });
       dispatch({type: ON_DELETE_PROSPEKT, payload: data.results});
      
     } else {
       dispatch({type: ON_ERROR_DELETE_PROSPEKT, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
    })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_PROSPEKT, payload: errorMessage});
    });
   }
}
//deleteThisProspekt
export const deleteThisProspekt = (Afid,userid,Avtal) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_PROSPEKT});
     axios.delete('kontos/Prospekt/delete', {
       method: 'DELETE',
       data: {
        Afid:Afid,
        userid:userid,
        Avtal:Avtal,ipAdress
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisProspekt: ", data);
     if (data.success) {
      let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
      dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
      history.push({
        pathname: '/app/Prospekt'
      });
       dispatch({type: ON_DELETE_PROSPEKT, payload: data.results});
      
     } else {
       dispatch({type: ON_ERROR_DELETE_PROSPEKT, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_PROSPEKT, payload: errorMessage});
   });
   }
}
//ForloradThisProspekt
export const ForloradThisProspekt =  (Afid,userid,Avtal,state,DstateObj) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_PROSPEKT_FORLORAD});
      axios.put('kontos/Prospekt/Forlorad', {
       body: {
         Afid:Afid,
         userid:userid,
         Avtal:Avtal,
         DstateObj:DstateObj,
         state:state,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("ForloradThisProspekt: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_PROSPEKT_FORLORAD, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
          dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Lose.Prospect",`Prospekt #19${Avtal.id} har förlorad`,{AvtalId:Avtal.id})});
         
        } else {
          dispatch({type: ON_ERROR_PROSPEKT_FORLORAD, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
        let prospektFilter =isUndefined(localStorage.ProspektFilter)?[]:JSON.parse(localStorage.ProspektFilter)
        dispatch(getProspektByUserid1(Afid,userid,0,prospektFilter))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_PROSPEKT_FORLORAD, payload: errorMessage});
      });
    }
 }
//TillBakaThisProspekt
export const TillBakaThisProspekt =  (Afid,userid,Avtal) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_PROSPEKT_TILLBAKA});
      axios.put('kontos/Prospekt/Tatillbaka', {
       body: {
         Afid:Afid,
         userid:userid,
         Avtal:Avtal,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("ForloradThisProspekt: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_PROSPEKT_TILLBAKA, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
        } else {
          dispatch({type: ON_ERROR_PROSPEKT_TILLBAKA, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_PROSPEKT_TILLBAKA, payload: errorMessage});
      });
    }
 }
//TillBakaThisAvtal
export const TillBakaThisAvtal =  (Afid,userid,Avtal) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_TILLBAKA});
      axios.put('kontos/Avtal/Tatillbaka', {
       body: {
         Afid:Afid,
         userid:userid,
         Avtal:Avtal,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("TillBakaThisAvtal: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_AVTAL_TILLBAKA, payload: data.results});
          dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
        } else {
          dispatch({type: ON_ERROR_AVTAL_TILLBAKA, payload: data.error});
        }
        //dispatch(RefreshUserInterface(userid))
      }).catch(function (error) {
        let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_TILLBAKA, payload: errorMessage});
      });
    }
 }
 
 

export const getAvtalFron=(userid,Afid,AvtalId,currentKund)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    axios.put('kontos/Document/getArcelorAvtal', {
      body: {
        Afid:Afid,
        userid:userid,
        AvtalId:AvtalId,
        currentKund:currentKund,ipAdress
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
        }
      })
    }
  /*
   const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    dispatch({type: ON_START_GET_AVTAL_Event_ID});
    axios.get('kontos/Avtal/Event/getByAid',
    { params:{Afid:Afid,userid:userid,Avtal:Aid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalMote: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_Event_ID, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_Event_ID, payload: data.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_AVTAL_KUNDDATA_ID, payload: error.message});
          if(!isUndefined(error.response.status)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
    }*/
}
//deleteThisAvtalAnteckning
export const deleteThisAvtalAnteckning = ( Orgnr, Afid, userid, AvtalId,HandelseId) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_AVTAL_HANDELSE});
     axios.delete('kontos/Avtal/Handelse/delete', {
       method: 'DELETE',
       data: {
        Orgnr:Orgnr,
         Afid:Afid,
         AvtalId:AvtalId,
         userid:userid,
         HandelseId:HandelseId,ipAdress
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteThisAvtalAnteckning: ", data.message);
     if (data.results) {
       console.log(data);
       dispatch({type: ON_DELETE_AVTAL_HANDELSE, payload: data.results});
       dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
     } else {
       dispatch({type: ON_ERROR_DELETE_AVTAL_HANDELSE, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_AVTAL_HANDELSE, payload: errorMessage});
   });
   }
}
//updateThisAvtalAnteckning
export const updateThisAvtalAnteckning = ( Orgnr, Afid, userid, AvtalId,Handelse) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_UPDATER_AVTAL_HANDELSE});
     axios.put('kontos/Avtal/Handelse/Edit', {
       body: {
        Orgnr:Orgnr,
         Afid:Afid,
         AvtalId:AvtalId,
         userid:userid,
         Handelse:Handelse,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("updateThisAvtalAnteckning: ", data.message);
     if (data.results) {
       console.log(data);
       dispatch({type: ON_UPDATER_AVTAL_HANDELSE, payload: data.results});
       dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
     } else {
       dispatch({type: ON_ERROR_UPDATER_AVTAL_HANDELSE, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_UPDATER_AVTAL_HANDELSE, payload:errorMessage});
   });
   }
}

//getOffertForthisAvtal
export const getOffertForthisAvtal = (userid,Afid,Aid,NoMes = 0) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_OFFERTL_ID});
    if(NoMes === 0){
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Offers")});
    }
    axios.get('kontos/Avtal/Offert/getByAid',
    { params:{Afid:Afid,userid:userid,Avtal:Aid,ipAdress}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalMote: ", data);
       if (data.results) {
        dispatch({type: ON_GET_AVTAL_OFFERTL_ID, payload: data.results});
        if(NoMes === 0){
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Offers")});
        } 
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_OFFERTL_ID, payload: data.error});
         dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.Offers")});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_OFFERTL_ID, payload: errorMessage});
       if(NoMes === 0){
       dispatch({type: ON_ERROR_MESSAGE_KUND, payload:errorMessage});
       } 
     }); /**/
  }
}
//deleteAvtalListByIds
export const deleteAvtalListByIds = ( Afid, userid, DeletedAvtallist,type,Page,searchWord,Pagerows,Filterstate,sortObj) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_AVTALLIST});
     axios.delete('kontos/Avtal/deleteList', {
       method: 'DELETE',
       data: {
         Afid:Afid,
         userid:userid,
         DeletedAvtallist:DeletedAvtallist,
         type:type,
         Page:Page,
         searchWord:searchWord,
         Pagerows:Pagerows,
         sortObj:sortObj,
         Filterstate:Filterstate,ipAdress
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("deleteAvtalListByIds: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_AVTALLIST, payload: data.results});
       
     } else {
       dispatch({type: ON_ERROR_DELETE_AVTALLIST, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_AVTALLIST, payload: errorMessage});
   });
   }
}
//ChangeOwnerAvtalListByIds
export const ChangeOwnerAvtalListByIds = ( Afid, userid,ansvarig, DeletedAvtallist,type,Page,searchWord,Pagerows,Filterstate,sortObj) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {    
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_CHANGE_ANSVARIG_AVTALLIST});
     axios.put('kontos/Avtal/NewAnsvarigList', {
       data: {
         Afid:Afid,
         userid:userid,
         DeletedAvtallist:DeletedAvtallist,
         type:type,
         ansvarig:ansvarig,
         Page:Page,
         searchWord:searchWord,
         Pagerows:Pagerows,
         sortObj:sortObj,
         Filterstate:Filterstate,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("ChangeOwnerAvtalListByIds: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_CHANGE_ANSVARIG_AVTALLIST, payload: data.results});
       
     } else {
       dispatch({type: ON_ERROR_CHANGE_ANSVARIG_AVTALLIST, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_CHANGE_ANSVARIG_AVTALLIST, payload: errorMessage});
   });
   }
}
//ChangeStartBillingAvtalListByIds
export const ChangeStartBillingAvtalListByIds = ( Afid, userid,BillingObj ,DeletedAvtallist,type,Page,searchWord,Pagerows,Filterstate,sortObj) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {    
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_CHANGE_START_BILLING_AVTALLIST});
     axios.put('kontos/Avtal/StartBillingList', {
       data: {
         Afid:Afid,
         userid:userid,
         DeletedAvtallist:DeletedAvtallist,
         type:type,
         Page:Page,
         sortObj:sortObj,
         Pagerows:Pagerows,
         BillingObj:BillingObj,
         searchWord:searchWord,
         Filterstate:Filterstate,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     if (data.success) {
       console.log(data);
       dispatch({type: ON_CHANGE_START_BILLING_AVTALLIST, payload: data.results});
       
     } else {
       dispatch({type: ON_ERROR_CHANGE_START_BILLING_AVTALLIST, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

    if (error.response) {
      // Server-side error handling
      switch (error.response.status) {
        case 400:
          errorMessage = translate("Error.BadRequest");
          break;
        case 401:
          errorMessage = translate("Error.Unauthorized");
          dispatch({ type: FETCH_START_SET_UNAUTHE });
          break;
        case 404:
          errorMessage = translate("Error.NotFound")
          break;
        case 500:
          errorMessage = translate("Error.Server")
          break;
        default:
          errorMessage = translate("Error.Generic")
      }
    } else if (error.message === "Network Error") {
      errorMessage = translate("Error.Network") ;
    }
     dispatch({type: ON_ERROR_CHANGE_START_BILLING_AVTALLIST, payload: errorMessage});
   });
   }
}

//ChangeDateAvtalListByIds
export const ChangeDateAvtalListByIds = ( Afid, userid,dateObj, DeletedAvtallist,type,Page,searchWord,Pagerows,Filterstate) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {    
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_CHANGE_DATE_AVTALLIST});
     axios.put('kontos/Avtal/NewdateList', {
       data: {
         Afid:Afid,
         userid:userid,
         DeletedAvtallist:DeletedAvtallist,
         type:type,
         dateObj:dateObj,
         Page:Page,
         Pagerows:Pagerows,
         searchWord:searchWord,
         Filterstate:Filterstate,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("ChangeDateAvtalListByIds: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_CHANGE_DATE_AVTALLIST, payload: data.results});
       
     } else {
       dispatch({type: ON_ERROR_CHANGE_DATE_AVTALLIST, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_CHANGE_DATE_AVTALLIST, payload: errorMessage});
   });
   }
}
//createNewKundIFortnoxFAvtal
export const createNewKundIFortnoxFAvtal = ( Orgrn, Afid, userid,AvtalID) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_FORTNOX_NEWKUND_AVTAL});
     axios.put('kontos/Avtal/Fortnox/NewKund', {
      body: {
        userid:userid,
        Afid:Afid,
        Orgrn:Orgrn,
        AvtalID:AvtalID,ipAdress
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("createNewKundIFortnoxFAvtal: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_NEWKUND_AVTAL, payload: data.results});
         dispatch(getAvtalByRestID(data.results.Avtal.Avtal[0].Orgnr,Afid,userid,data.results.Avtal.Avtal[0].id))
       } else {
         dispatch({type: ON_ERROR_FORTNOX_NEWKUND_AVTAL, payload:data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_FORTNOX_NEWKUND_AVTAL, payload: errorMessage});
     });
   }
 }
//getFortnoxKundFFbyKundnummerAvtal
export const getFortnoxKundFFbyKundnummerAvtal = ( Orgrn, Afid, userid,AvtalID,FortnoxKundNR) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_FORTNOX_NEWKUND_AVTAL});
     axios.put('kontos/Avtal/Fortnox/getKund', {
      body: {
        userid:userid,
        Afid:Afid,
        FortnoxKundNR:FortnoxKundNR,
        AvtalID:AvtalID,
        Orgrn:Orgrn,ipAdress
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("getFortnoxKundFFbyKundnummer: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_FORTNOX_NEWKUND_AVTAL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_FORTNOX_NEWKUND_AVTAL, payload: data.error});
       }
       //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_FORTNOX_NEWKUND_AVTAL, payload: errorMessage});
     });
   }
 }
 //ImportAvtalKunddataExcelFile
 export const ImportAvtalKunddataExcelFile = (Afid,userid,Orgnr,Aid,fileObj) =>{
  const jwt =  JSON.parse(localStorage.token);
 return async (dispatch) => {
    let files = fileObj.file; 
  console.log(files)
  const ipAdress='0.0.0.0'
  var fromdata = new FormData();
  fromdata.append("Afid",Afid)
  fromdata.append("userid",userid)
  fromdata.append("Orgnr",Orgnr)
  fromdata.append("AvtalId",Aid)
  fromdata.append("AttFunction",fileObj.AttFunction)
  fromdata.append("ipAdress",ipAdress)
  files.forEach(file => fromdata.append('files[]', file));
  
    
    dispatch({type: ON_START_AVTAL_IMPORT_KD_EXCEL});
    axios.post('kontos/Avtal/Kunddata/import',
    fromdata,
     {
       body:{
        Afid:Afid,
        userid:userid,
        Orgnr:Orgnr,
        AttFunction:fileObj.AttFunction,
        AvtalId:Aid,ipAdress
       },
       headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
     }
     ).then(({data}) => {
      console.log("ImportAvtalKunddataExcelFile: ", data);
      if (data) {
        dispatch({type: ON_AVTAL_IMPORT_KD_EXCEL, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_AVTAL_IMPORT_KD_EXCEL, payload: data.message});
       }
     //dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_AVTAL_IMPORT_KD_EXCEL, payload:errorMessage});
   });
  }
 }
 //SaveKunddataTemp
export const SaveAvtalKunddataTemp =  (Afid,userid,Orderid,AvtalId,Kunddata,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_KUNDDATA_TEMPORARY});
      axios.put('kontos/Avtal/Kunddata/saveTemporary', {
       body: {
         Afid:Afid,
         userid:userid,
         Orderid:Orderid,
         AvtalId:AvtalId,
         Orgnr:Orgnr,
         Kunddata:Kunddata,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("SaveAvtalKunddataTemp: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_AVTAL_KUNDDATA_TEMPORARY, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_AVTAL_KUNDDATA_TEMPORARY, payload: data.error});
        }
      //////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_KUNDDATA_TEMPORARY, payload: errorMessage});
      });
    }
 }
 //StartBillingthisAvtal
 export const StartBillingthisAvtal =  (Afid,userid,Orgnr,Avtal,BillingObj) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_BILLING_START});
      axios.put('kontos/Avtal/Billing/Start', {
       body: {
         Afid:Afid,
         Orgnr:Orgnr,
         userid:userid,
         AvtalId:Avtal,
         BillingObj:BillingObj,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("StartBillingthisAvtal: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_AVTAL_BILLING_START, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_AVTAL_BILLING_START, payload: data.error});
        }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_BILLING_START, payload: errorMessage});
      });
    }
 }
 
 //CloseBillingthisAvtal
 export const CloseBillingthisAvtal =  (Afid,userid,Orgnr,Avtal) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_BILLING_CLOSE});
      axios.put('kontos/Avtal/Billing/Close', {
       body: {
         Afid:Afid,
         Orgnr:Orgnr,
         userid:userid,
         AvtalId:Avtal,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("SaveAvtalKunddataTemp: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_AVTAL_BILLING_CLOSE, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_AVTAL_BILLING_CLOSE, payload: data.error});
        }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_BILLING_CLOSE, payload: errorMessage});
      });
    }
 }
//updateNewBillingAvtal
export const updateNewBillingAvtal =  (Afid,userid,Orgnr,BillingObj,isfrom) =>{
  let isFrom = isUndefined(isfrom)?0:1
  /*
  isFrom === 0 avtal without creating faktura 
  isFrom === 1 avtal with creating  faktura 
  */
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_AVTAL_BILLING_UPDATE});
      axios.put('kontos/Avtal/Billing/update', {
       body: {
         Afid:Afid,
         userid:userid,
         Orgnr:Orgnr,
         BillingObj:BillingObj,ipAdress,isFrom
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("StartBillingthisAvtal: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_AVTAL_BILLING_UPDATE, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_AVTAL_BILLING_UPDATE, payload: data.error});
        }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_AVTAL_BILLING_UPDATE, payload: errorMessage});
      });
    }
 }
 //ChangeSlutBillingAvtalListByIds
export const ChangeSlutBillingAvtalListByIds = ( Afid, userid,DeletedAvtallist,type,Page,searchWord,Pagerows,Filterstate,sortObj) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {    
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_CHANGE_CLOSE_BILLING_AVTALLIST});
     axios.put('kontos/Avtal/CloseBillingList', {
       data: {
         Afid:Afid,
         userid:userid,
         DeletedAvtallist:DeletedAvtallist,
         type:type,
         Page:Page,
         Pagerows:Pagerows,
         sortObj:sortObj,
         searchWord:searchWord,
         Filterstate:Filterstate,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("ChangeSlutBillingAvtalListByIds: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_CHANGE_CLOSE_BILLING_AVTALLIST, payload: data.results});
       
     } else {
       dispatch({type: ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_CHANGE_CLOSE_BILLING_AVTALLIST, payload: errorMessage});
   });
   }
}
//ChangeSkapaBillingAvtalListByIds
export const ChangeSkapaBillingAvtalListByIds = ( Afid, userid,startDate,DeletedAvtallist,type,Page,searchWord,Pagerows,Filterstate,sortObj,selectedlist) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {   
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_CHANGE_SKAPA_BILLING_AVTALLIST});
     axios.put('kontos/Avtal/CreateBillingList', {
       data: {
         Afid:Afid,
         userid:userid,
         startDate:startDate,
         DeletedAvtallist:DeletedAvtallist,
         type:type,
         Page:Page,
         sortObj:sortObj,
         Pagerows:Pagerows,
         searchWord:searchWord,
         selectedlist:selectedlist,
         Filterstate:Filterstate,ipAdress
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("ChangeSkapaBillingAvtalListByIds: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_CHANGE_SKAPA_BILLING_AVTALLIST, payload: data.results});
       
     } else {
       dispatch({type: ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_CHANGE_SKAPA_BILLING_AVTALLIST, payload: errorMessage});
   });
   }
}
//setAvtalVyType
export const setAvtalVyType = (Type) => {
  return async (dispatch) => {
    dispatch({type:SET_AVTALVY_TYPE,payload:Type});
  }
}
//setAvtalPage
export const setAvtalPage = (Page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_AVTAL_PAGE_BASIC, payload: {Page:Page+1}});
   }
}
//onCloseAvtalToaster
export const onCloseAvtalToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_CLOSE_AVTAL_TOASTR});
  }
}
//getAfidInvoicesByAvtal
export const getAfidInvoicesByAvtal = (userid,Afid,Avtalid,OrderId,page,retu = 0) =>{
  let Page = isUndefined(page)?0:page
 const jwt =  JSON.parse(localStorage.token);
 return async (dispatch) => {
   const ipAdress='0.0.0.0'
   dispatch({type: ON_START_GET_AVTAL_FAKTUROR});
   dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Invoices")});
   axios.get('kontos/Avtal/Fakturor/getByAvtal',
   { params:{
    Afid:Afid,userid:userid,page:Page,Avtalid:Avtalid,ipAdress,retu, OrderId}, 
    headers: { 'Authorization': `Bearer ${jwt}`} }      
    ).then(({data}) => {
     console.log("getAvtalByOrgnr: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
       if(!isUndefined(data.results.requ)){
       if(parseInt(data.results.requ) === 1){
        //delay 1 sec
        setTimeout(() => {
          dispatch(getAfidInvoicesByAvtal(userid,Afid,Avtalid,undefined,page,1))
        }, 1000);
        
       }else{
        dispatch({type: ON_GET_AVTAL_FAKTUROR, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Invoices")});
       }
      }else{
        dispatch({type: ON_GET_AVTAL_FAKTUROR, payload: data.results});
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Invoices")});
      }
      } else {
        dispatch({type: ON_ERROR_GET_AVTAL_FAKTUROR, payload: data.error});
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.Invoices")});
      }
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
      dispatch({type: ON_ERROR_GET_AVTAL_FAKTUROR, payload: errorMessage});
      dispatch({type: ON_ERROR_MESSAGE_KUND, payload: errorMessage});
    });
 }
}
//getAvtalFreeInputs
export const getAvtalFreeInputs = (userid,Afid,Avtalid) =>{
 const jwt =  JSON.parse(localStorage.token);
 return async (dispatch) => {
   const ipAdress='0.0.0.0'
   dispatch({type: ON_START_GET_AVTAL_FREEINPUTS});
   axios.get('kontos/Avtal/FreeInputs/get',
   { params:{
    Afid:Afid,userid:userid,Avtalid:Avtalid}, 
    headers: { 'Authorization': `Bearer ${jwt}`} }      
    ).then(({data}) => {
     console.log("getAvtalByOrgnr: ", data);
      if (data.results) {
       // dispatch({type: FETCH_ALL_CONTACT});
        dispatch({type: ON_GET_AVTAL_FREEINPUTS, payload: data.results});
      } else {
        dispatch({type: ON_ERROR_GET_AVTAL_FREEINPUTS, payload: data.error});
      }
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
      dispatch({type: ON_ERROR_GET_AVTAL_FREEINPUTS, payload: errorMessage});
    });
 }
}
//getAvtalTasks
export const getAvtalTasks = (userid,Afid,Avtalid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_OTASKS});
    axios.get('kontos/Avtal/Otasks',
    { params:{
     Afid:Afid,userid:userid,Avtalid:Avtalid}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AVTAL_OTASKS, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_OTASKS, payload: data.error});
       }
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_OTASKS, payload: errorMessage});
     });
  }
 }
 //onKalkylAllreadySaved
 export const onKalkylAllreadySaved = () =>{
  return async (dispatch) => {
    dispatch({type: KALKYL_ALLREADY_SAVED});
  }
 }
//getAvtalSharedKunder
export const getAvtalSharedKunder = (Afid,userid,AvtalId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_AVTAL_SHARED_KUNDER});
    axios.get('kontos/Avtal/SharedKunder',
    { params:{
     Afid:Afid,userid:userid,AvtalId:AvtalId}, 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then(({data}) => {
      console.log("getAvtalByOrgnr: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         dispatch({type: ON_GET_AVTAL_SHARED_KUNDER, payload: data.results});
       } else {
         dispatch({type: ON_ERROR_GET_AVTAL_SHARED_KUNDER, payload: data.error});
       }
     }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
       dispatch({type: ON_ERROR_GET_AVTAL_SHARED_KUNDER, payload: errorMessage});
     });
  }
 }
//onDeleteThisSharedKund
export const onDeleteThisSharedKund = ( userid,Afid,AvtalId,DelOrg) =>{
  const jwt = JSON.parse(localStorage.token);;
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
     dispatch({type: ON_START_DELETE_AVTAL_SHARED_KUNDER});
     axios.delete('kontos/Avtal/SharedKunder/delete', {
       method: 'DELETE',
       data: {
         Afid:Afid,
         userid:userid,
         AvtalId:AvtalId,
         DelOrg:DelOrg
       },
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
     console.log("onDeleteThisSharedKund: ", data.results.message);
     if (data.success) {
       console.log(data);
       dispatch({type: ON_DELETE_AVTAL_SHARED_KUNDER, payload: data.results});
       
     } else {
       dispatch({type: ON_ERROR_DELETE_AVTAL_SHARED_KUNDER, payload: data.error});
     }
     //dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
     dispatch({type: ON_ERROR_DELETE_AVTAL_SHARED_KUNDER, payload: errorMessage});
   });
   }
}
//onAddnewSKundAvtal
export const onAddnewSKundAvtal =  (Afid,userid,Avtal,Orgnr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress='0.0.0.0'
      dispatch({type: ON_START_ADD_AVTAL_SHARED_KUNDER});
      axios.put('kontos/Avtal/SharedKunder/add', {
       body: {
         Afid:Afid,
         Orgnr:Orgnr,
         userid:userid,
         AvtalId:Avtal
       }},{
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then(({data}) => {
       console.log("StartBillingthisAvtal: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_ADD_AVTAL_SHARED_KUNDER, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_ADD_AVTAL_SHARED_KUNDER, payload: data.error});
        }
      //dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
      let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
        dispatch({type: ON_ERROR_ADD_AVTAL_SHARED_KUNDER, payload: errorMessage});
      });
    }
 }
 
export const onChangeProspektKund =(Afid,userid,AvtalId,Orgnr,goto = 1)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_CHANGE_PROSPEKT_KUND});
    axios.put('kontos/Prospekt/KundChange', {
      body: {
        Afid:Afid,
        Orgnr:Orgnr,
        userid:userid,
        AvtalId:AvtalId,
        IpAdress
      }},{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
    console.log("onChangeProspektKund: ", data);
    if (data.results) {
      if(goto === 1){
        localStorage.setItem("Avtal",`${AvtalId}_${Orgnr}`);
        dispatch(getAvtalByID(Orgnr,Afid,userid,AvtalId))
        dispatch({type: ON_CHANGE_PROSPEKT_KUND, payload: data.results});
      }
     } else {
       dispatch({type: ON_ERROR_CHANGE_PROSPEKT_KUND, payload: data.error});
     }
  })
  .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
    dispatch({type: ON_ERROR_CHANGE_PROSPEKT_KUND, payload: errorMessage});
  });
  }
}

export const getProspektExtraInfo = (AvtalId) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_CHANGE_PROSPEKT_KUND});
    return await axios.get('kontos/Prospekt/getExtraInfo', {
      method: 'GET',
      params: {
        AvtalId
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
    console.log("getProspektExtraInfo: ", data);
    if (data.success) {
      return data.AvtalInfo
     }
  })
  .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
    dispatch({type: ON_ERROR_CHANGE_PROSPEKT_KUND, payload: errorMessage});
  });
  }
}
//onCheckAvtalkanOrder
export const onCheckAvtalkanOrder = (Afid,userid,Avtal,callback) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch,getState) => {
    const {IpAdress} = getState().auth;
    dispatch({type: ON_START_CHANGE_PROSPEKT_KUND});
    return await axios.get('kontos/Prospekt/Check', {
      method: 'GET',
      params: {
        Avtal:Avtal,
        Afid:Afid,
        userid:userid
      },
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
    console.log("getProspektExtraInfo: ", data);
    callback(data.results)
  })
  .catch(function (error) {
    let errorMessage = translate("Error.Unknown");

       if (error.response) {
         // Server-side error handling
         switch (error.response.status) {
           case 400:
             errorMessage = translate("Error.BadRequest");
             break;
           case 401:
             errorMessage = translate("Error.Unauthorized");
             dispatch({ type: FETCH_START_SET_UNAUTHE });
             break;
           case 404:
             errorMessage = translate("Error.NotFound")
             break;
           case 500:
             errorMessage = translate("Error.Server")
             break;
           default:
             errorMessage = translate("Error.Generic")
         }
       } else if (error.message === "Network Error") {
         errorMessage = translate("Error.Network") ;
       }
    dispatch({type: ON_ERROR_CHANGE_PROSPEKT_KUND, payload: errorMessage});
  });
  }
}
